<template>
  <div>
    <section id="wat-wij-doen" class="content-wrapper page">
      <section class="row header">
        <ul class="breadcrumb">
          <li><router-link class="link" to="/">Home</router-link></li>
          <li>
            <router-link to="/wat-wij-doen"
              ><inline-svg
                src="/images/icons/chevron-right-solid.svg"
              ></inline-svg
              >Wat wij doen</router-link
            >
          </li>
          <li>
            <inline-svg src="/images/icons/chevron-right-solid.svg"></inline-svg
            >Digitaliseren
          </li>
        </ul>
        <div class="col text">
          <h1>Schep ruimte en overzicht met een digitaal archief</h1>
          <h2>Digitaliseren en archiveren</h2>
          <p>
            Rijnja is specialist in het digitaliseren van documenten en
            archieven. We digitaliseren documenten, van één rapport of
            bouwtekening tot een compleet archief, en leveren digitale,
            doorzoekbare informatie terug. Ruimte scheppen, geen risico meer
            lopen op verlies of (brand- en water)schade. Een beter overzicht
            creëren, de toegankelijkheid vergroten; laat het papieren archief
            achter u.
          </p>
          <a class="link-button top-button" href="#contact"
            >Neem contact met ons op</a
          >

          <h2>Veilig doorzoeken en delen</h2>
          <p>
            In een digitaal archief zijn documenten toegankelijk en makkelijk
            doorzoekbaar voor iedereen in de organisatie die daartoe toegang
            heeft. Hoeveel efficiënter en ruimtebesparend is het digitale
            archief? Documenten zijn veel sneller te vinden, te bekijken en te
            delen. En, als het echt nodig is, te printen.
          </p>

          <h2>Van A tot Z geregeld</h2>
          <p>
            Het gehele proces van digitaliseren gebeurt bij ons in eigen beheer.
            Van het beveiligd ophalen van uw archief met onze eigen koeriers, de
            fysieke en digitale opslag ervan tot en met het opleveren van uw
            digitale archief. En uiteraard, in overleg met u, het gecertificeerd
            laten vernietigen van uw papieren archief. Rijnja regelt het en
            neemt alle verantwoordelijkheid voor de uitvoering.
          </p>
        </div>
        <div class="col header-circle-image">
          <div class="rijnja-amsterdam"></div>
          <!-- <printen-en-meer></printen-en-meer> -->
        </div>
      </section>

      <section class="row full">
        <div class="col text">
          <h2>Betrouwbare kwaliteit</h2>
          <p>
            Wij investeren voortdurend in vernieuwende technologie en duurzame
            technieken voor veilige en innovatieve online-oplossingen. Wij
            werken volgens de hoogste en nieuwste kwaliteits- en
            milieumanagementnormen. Vanzelfsprekend zijn wij ISO 9001:2015 en
            ISO 14001:2015 gecertificeerd. We waarborgen de beveiliging en
            vertrouwelijkheid van uw bestanden en gegevens gedurende het gehele
            proces. Niet voor niets zijn wij gecertificeerd volgens de nieuwste
            norm, ISO 27001:2022.
            <router-link class="link-text" to="/home#voor-wie">
              Deze tevreden opdrachtgevers</router-link
            >
            gingen u voor.
          </p>
        </div>
      </section>

      <section class="row image-row">
        <img
          class=""
          src="@/images/pages/digitaliseer-en-doorzoek-uw-archief.svg"
        />
      </section>
      <div class="anchor-tag" id="contact"></div>
      <section class="row" id="">
        <div class="col-single">
          <h1>Wilt u meer weten over onze diensten?</h1>
          <p>
            Benieuwd naar wat Koninklijke Rijnja voor u kan betekenen? Neem dan
            contact met ons op via onderstaand formulier.
          </p>

          <contact-form
            recipient="verkoop@rijnja.nl"
            class="form"
            subject="Informatieaanvraag diensten"
            conversion-id="McMQCKuxhJwYEKDetesD"
          ></contact-form>
          <p>
            Wilt u een van onze vestigingen direct bereiken? Bekijk de
            contactgegevens dan op onze
            <router-link class="link-text" to="/contact"
              >contactpagina</router-link
            >.
          </p>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import ContactForm from '../../components/ContactForm.vue'
import SiteFooter from '../../components/SiteFooter.vue'
import PrintenEnMeer from './PrintenEnMeer.vue'
export default {
  components: { SiteFooter, PrintenEnMeer, ContactForm }
}
</script>

<style lang="scss" scoped>
.top-button {
  margin-bottom: 35px;
}
.archiveren {
  max-width: 360px;
}
.bestellen-bezorgen {
  max-width: 375px;
}

.kwaliteit {
  max-width: 370px;
}

.security {
  max-width: 400px;
}

.printstore {
  max-width: 365px;
}

.portals {
  max-width: 450px;
}

.form {
  margin: 20px 0;
}
.rijnja-amsterdam {
  background-image: url('@/images/pages/rijnja-digitaliseren.jpg');
  width: 966px;
  height: 966px;
  border-radius: 50%;

  position: absolute;
  //top: -404px;
  top: -350px;
  left: 0;
  /*   background-position-x: -32px;
  background-position-y: 226px;
  background-size: 86%; */
  background-position-y: 126px;
  background-size: cover;
}

.row.header {
  padding-bottom: 0;
}

.row.image-row {
  padding-top: 0;
  padding-bottom: 0;

  img {
    max-width: 955px;
    margin: 0 auto;
    width: 100%;
  }
}

.row.full {
  padding-top: 0;
}

.row.header {
  padding-bottom: 0;
}
</style>
